import { render, staticRenderFns } from "./IcoEnvironment.vue?vue&type=template&id=536a7e1f&scoped=true"
import script from "./IcoEnvironment.vue?vue&type=script&lang=js"
export * from "./IcoEnvironment.vue?vue&type=script&lang=js"
import style0 from "./IcoEnvironment.vue?vue&type=style&index=0&id=536a7e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536a7e1f",
  null
  
)

export default component.exports